import dayjs from 'dayjs';
import { IAppraisal } from '@/models/order.model';

export const normalizeAppraiserData = (data?: IAppraisal) => ({
  ...data,
  condition_report_created_at: data?.condition_report_created_at ? dayjs(data?.condition_report_created_at) : undefined,
  rate_report_created_at: data?.rate_report_created_at ? dayjs(data?.rate_report_created_at) : undefined,
});
